import { dataFolderDownloadSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderDownloadSolid = /*#__PURE__*/createIcon(dataFolderDownloadSolid)
export default IconFolderDownloadSolid
